import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
import { ShimmerText } from '@/components/ui/shimmer-text';
import { cn } from '@/lib/utils';

interface PartnrSendButtonProps {
  hasText: boolean;
  isStreaming: boolean;
  onSubmit: () => void;
  className?: string;
}

/**
 * Send arrow that morphs in once there is text, and a "Thinking…" shimmer
 * while Partnr replies. Shared by the toolbar compose box and the side chat.
 */
export function PartnrSendButton({ hasText, isStreaming, onSubmit, className }: PartnrSendButtonProps) {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {isStreaming ? (
        <motion.span
          key="thinking"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="text-[11px] px-1"
        >
          <ShimmerText>Thinking…</ShimmerText>
        </motion.span>
      ) : hasText ? (
        <motion.button
          key="send"
          type="button"
          onClick={onSubmit}
          aria-label="Send to Partnr"
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          transition={{ duration: 0.15 }}
          className={cn(
            'h-6 w-6 rounded-full bg-partnr text-partnr-foreground flex items-center justify-center hover:opacity-90',
            className,
          )}
        >
          <ArrowUp className="h-3.5 w-3.5" />
        </motion.button>
      ) : null}
    </AnimatePresence>
  );
}
